import { getNotificationsList } from '@/fsd/entities/notifications/api/getNotificationsList/getNotificationsList';
import { NotificationStatus } from '@/fsd/entities/notifications/model/types/types';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

interface IParams {
  status: NotificationStatus;
}

export const useAllNotificationsList = ({ status }: IParams) => {
  const {
    data,
    error,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useInfiniteQuery({
    queryKey: ['notifications', status],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await getNotificationsList({
        status: status,
        page: pageParam,
      });

      return response;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage && lastPage.meta.current_page < lastPage.meta.last_page) {
        return lastPage.meta.current_page + 1;
      }
      return undefined;
    },
  });

  const notificationList = useMemo(
    () => data?.pages.flatMap((page) => page?.data || []) || [],
    [data]
  );

  return {
    notificationList,
    loading: isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  };
};
